import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import HowToMakeOrder from "../../components/pages/HowToPay/HowToMakeOrder/HowToMakeOrder";
import PayAttention from "../../components/pages/HowToPay/PayAttention/PayAttention";
import Important from "../../components/pages/HowToPay/Important/Important";
import Sale from "../../components/pages/HowToPay/Sale/Sale";

const HowToPayPage: React.FC = () => {
  return (
    <Layout>
      <HowToMakeOrder />
      <PayAttention />
      <Sale />
      <Important />
      <Feedback />
    </Layout>
  );
};

export default HowToPayPage;
